import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'
import { type AxiosError } from 'axios'

import { type ParcelShopLocationDto } from '../api/index.schemas'
import { client } from '../mutator/client'

export type UseGetParcelShopLocationsByKeysArgs = {
  countryCode: string
  postalCode: string
  servicePointIds: string[]
}

type ParcelShopLocationResult = {
  results: ParcelShopLocationDto[]
}

export const getParcelShopLocationsByKeys = ({
  countryCode,
  postalCode,
  servicePointIds,
}: UseGetParcelShopLocationsByKeysArgs) => {
  const idParams = servicePointIds.map((id) => `psfKey=${id}`).join('&')
  return client<ParcelShopLocationResult>({
    url: `/parcel-shop-locations/${countryCode}/by-keys?postalCode=${postalCode}&${idParams}`,
    method: 'GET',
  })
}

export const useGetParcelShopLocationsByKeys = <TData = Awaited<ReturnType<typeof getParcelShopLocationsByKeys>>>(
  { countryCode, postalCode, servicePointIds }: UseGetParcelShopLocationsByKeysArgs,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsByKeys>>, AxiosError, TData>>
  }
): UseQueryResult<TData, AxiosError> =>
  useQuery({
    ...options?.query,
    queryKey: ['/parcel-shop-locations', countryCode, 'by-keys', postalCode, servicePointIds],
    queryFn: () => getParcelShopLocationsByKeys({ countryCode, postalCode, servicePointIds }),
  })
